<template>
  <v-dialog v-model="showModal">
    <v-card>
      <v-card-title>
        <span class="headline">
          <v-icon>fa fa-book</v-icon>
          Certificates
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="temporaryCertificates"
                class="elevation-1"
              >
                <template #item.created_at="{ item }">
                  <span v-if="item.created_at">
                    {{ item.created_at | displayDateTime }}
                  </span>
                  <span v-else>
                    No Date
                  </span>
                </template>
                <template #item.actions="{ item }">
                  <v-btn
                      @click="sendCertificate(item)"
                      :disabled="item.units !== item.completed_units && !isEmpty(item.created_at)"
                      :loading="loading"
                  >
                    Send Certificate
                  </v-btn>
                </template>
                <template #item.is_sent="{ item }">
                  <span v-if="item.is_sent === 0">
                    No
                  </span>
                  <span v-else>
                    Yes
                  </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  findIndex as _findIndex,
  isEmpty as _isEmpty,
} from 'lodash-es';

export default {
  name: 'CertificatesModal',
  props: {
    value: {
      default: false,
    },
    updateRow: {
      type: Function,
    },
    certificates: {
      default: [
        {
          name: '',
          units: '',
          completed_units: '',
          actions: '',
        },
      ],
    },
  },
  data () {
    return {
      temporaryCertificates: [],
      isEmpty: _isEmpty,
      loading: false,
      headers: [
        {
          text: 'Module',
          tooltip: 'Module',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Total No of Units',
          align: 'center',
          sortable: true,
          value: 'units',
        },
        {
          text: 'Completed Units',
          align: 'center',
          sortable: true,
          value: 'completed_units',
        },
        {
          text: 'Certificate Sent',
          align: 'center',
          sortable: true,
          value: 'is_sent',
        },
        {
          text: 'Certificate Issue Date',
          align: 'center',
          sortable: true,
          value: 'created_at',
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: true,
          value: 'actions',
        },
      ],
    };
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.temporaryCertificates = this.certificates;
        console.log(this.certificates);
      }
    },
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
      },
    },
  },
  methods: {
    sendCertificate(certificate) {
      this.loading = true;
      this.$http.post('/client/reports/lms/manual-send-certificate', {
        user: certificate.user_id,
        series: certificate.name,
        category: certificate.category,
      })
      .then(({ data }) => {
        const index = _findIndex(this.temporaryCertificates, { name: certificate.name });
        this.temporaryCertificates[index].is_sent = 1;
        this.temporaryCertificates[index].created_at = data.created_at;
        this.$notify('success', 'Certificate sent');
        this.updateRow(certificate.user_id);
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>

</style>